import { render } from "./FilesView.vue?vue&type=template&id=03a88778&scoped=true"
import script from "./FilesView.vue?vue&type=script&lang=js"
export * from "./FilesView.vue?vue&type=script&lang=js"

import "./FilesView.vue?vue&type=style&index=0&id=03a88778&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a88778"]])

export default __exports__